module.exports = __webpack_public_path__ + "img/bg-dhzjgk.297504d8.png";